import { NavLink as RouterNavLink } from "react-router";

import type { PartialNavProps } from "./types";

export function getNavProps(to?: string, end?: boolean) {
  return to ? ({ to, component: RouterNavLink, end } as PartialNavProps) : undefined;
}

export function getTextProps(pathname: string, to?: string) {
  const isActive = to ? pathname.startsWith(to) : false;
  return isActive ? { "aria-current": true } : undefined;
}
